import { useEffect, useState } from 'react';

export const RN_NOTIFICATION_EVENT = 'rn:notification';
export const REQUEST_NOTIFICATION_FIELDS = 'REQUEST_NOTIFICATION_FIELDS';

export function isReactNativeWebView() {
  return typeof window !== 'undefined' && !!window.ReactNativeWebView;
}

export function requestNotificationFieldsFromNative() {
  if (!isReactNativeWebView()) {
    return;
  }

  window.ReactNativeWebView.postMessage(JSON.stringify({ type: REQUEST_NOTIFICATION_FIELDS }));
}

/**
 * Returns native notification fields when all required values are present.
 * Omits fields when any value is missing so auth still works without them.
 */
function getAuthNotificationPayload(notificationFields) {
  if (
    !notificationFields?.device_id ||
    !notificationFields?.token ||
    notificationFields?.permission === undefined
  ) {
    return {};
  }

  return {
    device_id: notificationFields.device_id,
    token: notificationFields.token,
    permission: notificationFields.permission,
    device_type: notificationFields.device_type || 'mobile',
  };
}

export function useNativeNotificationFields() {
  const [notificationFields, setNotificationFields] = useState(null);

  useEffect(() => {
    if (!isReactNativeWebView()) {
      return undefined;
    }

    const handleNativeNotification = (event) => {
      //   console.log('---Received data from react native:', event?.detail);
      if (event?.detail) {
        setNotificationFields(event.detail);
      }
    };

    window.addEventListener(RN_NOTIFICATION_EVENT, handleNativeNotification);
    requestNotificationFieldsFromNative();

    return () => {
      window.removeEventListener(RN_NOTIFICATION_EVENT, handleNativeNotification);
    };
  }, []);

  return getAuthNotificationPayload(notificationFields);
}
